export default __webpack_public_path__ + "static/media/download.80dcea83.png";